"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    APP_SEO_REACH: [
        {
            entitlement: "B2B2024_AppSEOReach",
        },
        {
            launchDarkly: "seo-reach-app-access",
        },
    ],
};
//# sourceMappingURL=reach.js.map